import {AppointmentCategory} from "@web-libs/features/appointments/domain/appointment.types";
import {useTheme} from "@web-libs/features/branding/theme/application/use-theme.concern";
import {addOpacityToHex} from "@web-libs/features/colors/application/colors";
import {Headline} from "@web-libs/ui/ui-components/typo/headline";
import {Text} from "@web-libs/ui/ui-components/typo/text";
import {CSSProperties} from "react";
import categoryStyles from "./category-item.module.css"
import ArrowIcon from "@web-libs/ui/svgs/icons/ArrowIcon";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {routes} from "@web-app/[lang]/[tenant]/[institution]/routes-institution";

type CategoryItemProps = {
    category: AppointmentCategory
    specId?: string
    style?: CSSProperties
}

export const CategoryItem = (props: CategoryItemProps) => {

    const theme = useTheme()

    const primaryColor = theme.getPrimary()
    const backgroundColor = addOpacityToHex(primaryColor, 0.3)

    const _style = {
        backgroundColor: backgroundColor,
        display: "flex",
        minHeight: 128,
        borderRadius: 30,
        cursor: "pointer",
        ...props.style
    }

    const router = useTageaRouter()
    const openCategory = () => {
        router.push(routes.appointmentBookingCategory(props.category.id, props.specId))
    }

    return (
        <div onClick={openCategory} className={categoryStyles.categoryItem} style={_style}>
            <div style={{flexGrow:1, padding:32}}>
                <Headline size={"sm"}>{props.category.name}</Headline>
                <Text block style={{marginTop:16}} size={"sm"}>{props.category.description}</Text>
            </div>
            <div style={{backgroundColor: "rgba(255,255,255,0.3)", flexShrink:0, width:100, display:"flex", justifyContent:"center", alignItems:"center"}}>
                <ArrowIcon height={36} width={36} color={"dark"}/>
            </div>
        </div>
    )
}
